const color = "#15749D";

export const fallbackValues = {
  color
};
